import React, { useContext, FC } from 'react'
import { DefaultContainer, Variant2Container, TitleContainer, Title, SeeButton, RoundCardContainer } from './styles'
import RoundCard from './components/RoundCard'
import ServiceArea from './components/ServiceArea'
import useTranslateMessage from '../../../hooks/useTranslateMessage'
import { AppDataContext } from '../../../providers/AppData'
import getDomainName from '../../../utils/getDomainName'
import getCountryByLocale from '../../../utils/getCountryByLocale'
import { TransformHomePageSpecialties } from '../../../types/homePage'
import { purifyTenantDomain } from '../../../utils/url'
import SectionItemVarTwo from './components/SectionItemVarTwo'

type Props = {
  specialties: TransformHomePageSpecialties[]
  variant?: 'default' | 'variant2'
}

const DefaultVariant: FC<Pick<Props, 'specialties'>> = ({ specialties }) => {
  const translate = useTranslateMessage()
  const { locale, language } = useContext(AppDataContext)
  const domainName = getDomainName()
  const originWithLang = purifyTenantDomain(domainName, locale)

  return (
    <DefaultContainer>
      <TitleContainer
        sx={{
          marginBottom: '40px'
        }}
      >
        <Title>{translate('home-page.specialties.title')}</Title>
        <SeeButton href={`${originWithLang}/find/all/${getCountryByLocale(locale)}/specialists`}>
          {translate('home-page.specialties.button')}
        </SeeButton>
      </TitleContainer>
      <RoundCardContainer
        sx={{
          marginBottom: { md: '96px', xs: '72px' }
        }}
      >
        {specialties.map(({ iconUri, icon, name, gradient, id, slug }) => (
          <RoundCard
            key={id}
            altIcon={iconUri}
            icon={icon}
            text={name[language]}
            gradient={gradient}
            linkToRedirect={`${originWithLang}/find/${slug}/${getCountryByLocale(locale)}/specialists`}
          />
        ))}
      </RoundCardContainer>
      <ServiceArea />
    </DefaultContainer>
  )
}

const Variant2: FC<Pick<Props, 'specialties'>> = ({ specialties }) => {
  const { locale, language } = useContext(AppDataContext)
  const domainName = getDomainName()
  const originWithLang = purifyTenantDomain(domainName, locale)

  return (
    <Variant2Container>
      {specialties.map(({ id, name, icon, slug }) => (
        <SectionItemVarTwo
          linkToRedirect={`${originWithLang}/find/${slug}/${getCountryByLocale(locale)}/specialists`}
          key={id}
          name={name[language]}
          img={icon}
        />
      ))}
    </Variant2Container>
  )
}

const SpecialtiesSection: FC<Props> = ({ specialties, variant = 'default' }) => {
  switch (variant) {
    case 'default': {
      return <DefaultVariant specialties={specialties} />
    }
    case 'variant2': {
      return <Variant2 specialties={specialties} />
    }
  }
}

export default SpecialtiesSection
